import crypto from "crypto";

if (typeof global.crypto === "undefined") {
  (global as typeof globalThis).crypto = crypto as any;
}
